<p-drawer 
    header="Posizione" 
    (onHide)="onClose.emit()" 
    [visible]="isDialogVisible()"
    position="right" 
    styleClass="!w-full md:!w-80 lg:!w-[30rem]">
    <spike-isin-form [form]="form"></spike-isin-form>

    <ng-template #footer>
        <div class="flex gap-4 w-full justify-between">

        @if(formView() || !data()){
        <div class="w-full">
            <p-button (click)="onSaveClicked()" [disabled]="form.invalid" icon="pi pi-save" label="Salva" severity="primary" styleClass="w-full"></p-button>
        </div>
        }
        </div>
    </ng-template>
</p-drawer>
